/**
 * `/welcome`, the first-visit intro tour on the web (ISSUE-1406), the same
 * three pages the phone shows on a fresh install. The root route sends a
 * signed-out visitor here instead of sign-in until this browser has seen it
 * once (`features/welcome/introTourGate.ts`), never in front of a deep link.
 * Every way out (Skip, Escape, Get started, I already have an account) marks
 * it seen and replaces to sign-in, where signing up and signing in are the
 * same step.
 *
 * Public, like `/sign-in`. A signed-in fan who opens it goes to Scores: the
 * tour is for people who have not signed in yet.
 */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { getAuthState } from "../auth/getAuthState";
import { IntroTour } from "../features/welcome/IntroTour";
import { markIntroTourSeen } from "../features/welcome/introTourStore";

const WelcomeScreen = (): ReactNode => {
  const navigate = useNavigate();
  return (
    <IntroTour
      onDone={() => {
        markIntroTourSeen();
        void navigate({
          to: "/sign-in",
          search: { step: "email" },
          replace: true,
        });
      }}
    />
  );
};

export const Route = createFileRoute("/welcome")({
  beforeLoad: () => {
    if (getAuthState().status !== "signedIn") return;
    // oxlint-disable-next-line typescript/only-throw-error
    throw redirect({ to: "/scores", search: {}, replace: true });
  },
  component: WelcomeScreen,
});
